// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles__key___K9kc6 {\n  height: 100%;\n  width: 5em;\n  cursor: pointer;\n  border: 1px solid #000;\n  border-radius: 4px;\n  color: #000;\n  display: flex;\n}\n.styles__playing___1bZs0 {\n  transform: scale(0.95) translate(0%, -2.5%);\n  box-shadow: 0px 3px 7px 0px #000;\n}\n.styles__key___K9kc6:focus {\n  outline: none;\n  border: 3px solid #015fcc;\n}\n.styles__accidental___1tyY- {\n  background: #000;\n  height: 60%;\n  width: 4em;\n  margin-left: -2em;\n  z-index: 1;\n  color: #fff;\n}\n.styles__accidental___1tyY- + .styles__key___K9kc6 {\n  margin-left: -2em;\n}\n.styles__visuallyHidden___1kvYh {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n", ""]);
// Exports
exports.locals = {
	"key": "styles__key___K9kc6",
	"playing": "styles__playing___1bZs0",
	"accidental": "styles__accidental___1tyY-",
	"visuallyHidden": "styles__visuallyHidden___1kvYh"
};
module.exports = exports;
